module.exports = __webpack_public_path__ + "img/桃花.097a67ac.png";